/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
  // 포스팅 생성
  async store(data?: any) {
    return camelize(await $axios.post(`/sns/posting`, snakelize(data)));
  },

  // 포스팅 수정
  async update(data?: any) {
    return camelize(
      await $axios.patch(`/sns/posting/${data.id}`, snakelize(data))
    );
  },

  // 포스팅 순서 수정
  async updateOrder(data?: any) {
    return camelize(await $axios.post(`/sns/posting/order`, snakelize(data)));
  },

  // 공개하기 토글
  async toggle(data?: any) {
    return camelize(await $axios.post(`/sns/posting/toggle`, snakelize(data)));
  },

  // 포스팅 이미지 삭제
  async deleteImage(data?: any) {
    return camelize(
      await $axios.delete(
        `/sns/posting/image/${data.url}`,
        snakelize({ data: data })
      )
    );
  },
});
